import { render, staticRenderFns } from "./CamphelferRegistration.vue?vue&type=template&id=05a8a7ea"
import script from "./CamphelferRegistration.vue?vue&type=script&lang=js"
export * from "./CamphelferRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports